import { Component, Inject } from '@angular/core';
import { MatDialogRef, MatDialogContent, MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { AlertButtonType } from './AlertButtonType.enum';

export interface DataAlert {
  title: string;
  content: string;
  buttonsAlert: AlertButtonType[];
}

@Component({
  selector: 'app-dialog-alert',
  standalone: true,
  imports: [ MatDialogModule ],
  templateUrl: './dialog-alert.component.html',
  styleUrl: './dialog-alert.component.scss'
})
export class DialogAlertComponent {

  constructor(
    public dialogSelfRef: MatDialogRef<DialogAlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DataAlert
  ) { }

}
